import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ApprovalList } from 'src/app/models/interface/CAM/approval-management';
import { CamService } from 'src/app/services/camService/cam.service';
import { ApprovalManagementService } from 'src/app/services/dataLayer/CAM/approval-management.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ApprovalContentService } from '../../services/approval-content.service';
import { NgIf } from '@angular/common';
import { MenuNavListingComponent } from '../menu-nav-listing/menu-nav-listing.component';
import { ApprovalListingComponent } from '../approval-listing/approval-listing.component';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { WaitingComponent } from 'src/app/shared/components/waiting/waiting.component';

@Component({
  selector: 'app-approval-management',
  templateUrl: './approval-management.component.html',
  styleUrls: ['./approval-management.component.scss'],
  imports: [NgIf, MenuNavListingComponent, RouterOutlet, ApprovalListingComponent, CamEmptyStateComponent, WaitingComponent]
})
export class ApprovalManagementComponent implements OnInit, OnDestroy {
  isFormActivate: boolean = false;
  isWorkflowSettingRoute: boolean = false;
  approvalList: ApprovalList[] = []
  isWaiting: boolean = false;
  isListing: any = (this._ActivatedRoute.snapshot as any)['_routerState']?.url?.includes("approval-listing");
  private readonly destroy$ = new Subject<void>();
  content: any;
  constructor(private readonly router: Router, private readonly _CamService: CamService, private readonly _ActivatedRoute: ActivatedRoute, private readonly _ToastrApiService: ToastrApiService, private readonly _ApprovalManagementService: ApprovalManagementService, private readonly contentService: ApprovalContentService) {
    this.router.events.subscribe(($router: any) => {
      if ($router instanceof NavigationStart) {
        this.isWorkflowSettingRoute =
          $router.url.includes('workflow-setting') || $router.url.includes('approvalflow-form');

        if ($router?.url.includes("approval-listing")) {
          this.isListing = true;
          this.loadApprovalList();
        } else {
          this.isListing = false;
        }

      }
    })
  }


  ngOnInit() {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    })
    this.loadApprovalList()

  }


  handleEvent(event: string) {
    console.log('add approval clicked')
    if (event.includes('approval-management')) {
      this._CamService.approvalWorkFlowSettingFormData = null;
      this.router.navigate(['/approval-management/workflow-setting']);
      this._ApprovalManagementService.approval_add('Add', this.approvalList.length)//GTM use

    }
  }
  loadApprovalList() {
    this.isWaiting = true;
    this._CamService.getApprovalManagementV1('newest', '').then((res) => {
      this.approvalList = res.data ?? [];
      this.isWaiting = false;
      this._ApprovalManagementService.sendData(this.approvalList); //sending data in Service
    }, (error) => {
      this.isWaiting = false;
      console.log('error ', error)
      this._ToastrApiService.show('error', 'Failed to load Approval workflow data data.');
      this.approvalList = [];
      console.error(error)
    })

  }
  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete();;
  }
}
